import { c as _c } from "react/compiler-runtime";
import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';
const dot = tv({
  base: 'rounded-full bg-current flex-shrink-0',
  variants: {
    variant: {
      default: 'bg-current',
      light: 'bg-content-secondary',
      dark: 'bg-content-primary',
      positive: 'bg-background-positive',
      warning: 'bg-background-warning',
      negative: 'bg-background-negative',
      neutral: 'bg-background-secondary'
    },
    size: {
      xs: 'size-0.5',
      sm: 'size-1',
      md: 'size-2',
      lg: 'size-3'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'sm'
  }
});
export interface DotProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof dot> {}
export default function Dot(t0) {
  const $ = _c(12);
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      size,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t1 = dot({
      className,
      variant,
      size
    });
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <div className={t1} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}